"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _InputBase = _interopRequireDefault(require("../InputBase"));
var _Label = _interopRequireDefault(require("../Label"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "labelClass", "required", "requiredMessage", "label", "description", "value", "setValue", "helperText", "disabled", "advanced", "tooltip", "tooltipNotchPosition", "mobileTooltipNotchPosition", "restrictFutureDates", "invalidErrorMessage", "onChange", "noErrorsOrHelper", "labelAlign", "valid", "id", "error", "errorText"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".InputDate {\n  display: flex;\n  flex-direction: column;\n}\n.InputDate__disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.InputDate__group {\n  display: flex;\n  border: none;\n}\n.InputDate__label_wrapper {\n  display: inline-flex;\n  outline: none;\n}\n.InputDate__label {\n  color: #767676;\n  font-size: 0.875rem;\n  line-height: 1rem;\n  font-weight: normal;\n  margin: 0.25rem;\n  display: flex;\n  transition: 0.2s ease all;\n}\n.InputDate__label__helper_text {\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n  color: #767676;\n  margin-bottom: 0;\n  margin-left: 0.25rem;\n  margin-top: auto;\n}\n.InputDate__label--required {\n  color: #c60f13;\n  margin-left: 0.25rem;\n}\n.InputDate__label__tooltip {\n  margin-left: 0.25rem;\n}\n.InputDate__label__error {\n  color: #c60f13;\n}\n.InputDate__day, .InputDate__month {\n  flex: 1;\n  margin-bottom: 0 !important;\n}\n.InputDate__year {\n  flex: 2;\n  margin-bottom: 0 !important;\n}\n.InputDate__error_text {\n  font-size: 0.75rem;\n  line-height: 1rem;\n  min-height: 1.25rem;\n  margin: 2px 0.25rem 0 0.25rem;\n  color: #767676;\n  font-weight: normal;\n}\n.InputDate__error_text.error {\n  font-weight: bold;\n  color: #c60f13;\n}\n.InputDate__separator {\n  flex: 0.125;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n}\n.InputDate__description {\n  margin: 0;\n  padding-left: 0.25rem;\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n  color: #767676;\n}";
  var fileName = "InputDate_InputDate";
  var element = document.querySelector("style[data-sass-component='InputDate_InputDate']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var InputDate = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$labelClass = _ref.labelClass,
    labelClass = _ref$labelClass === void 0 ? '' : _ref$labelClass,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$requiredMessage = _ref.requiredMessage,
    requiredMessage = _ref$requiredMessage === void 0 ? '' : _ref$requiredMessage,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? '' : _ref$description,
    value = _ref.value,
    _ref$setValue = _ref.setValue,
    setValue = _ref$setValue === void 0 ? function () {} : _ref$setValue,
    _ref$helperText = _ref.helperText,
    helperText = _ref$helperText === void 0 ? '' : _ref$helperText,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$advanced = _ref.advanced,
    advanced = _ref$advanced === void 0 ? false : _ref$advanced,
    _ref$tooltip = _ref.tooltip,
    tooltip = _ref$tooltip === void 0 ? '' : _ref$tooltip,
    _ref$tooltipNotchPosi = _ref.tooltipNotchPosition,
    tooltipNotchPosition = _ref$tooltipNotchPosi === void 0 ? 'bottom-left' : _ref$tooltipNotchPosi,
    _ref$mobileTooltipNot = _ref.mobileTooltipNotchPosition,
    mobileTooltipNotchPosition = _ref$mobileTooltipNot === void 0 ? 'bottom-right' : _ref$mobileTooltipNot,
    _ref$restrictFutureDa = _ref.restrictFutureDates,
    restrictFutureDates = _ref$restrictFutureDa === void 0 ? false : _ref$restrictFutureDa,
    _ref$invalidErrorMess = _ref.invalidErrorMessage,
    invalidErrorMessage = _ref$invalidErrorMess === void 0 ? '' : _ref$invalidErrorMess,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$noErrorsOrHelper = _ref.noErrorsOrHelper,
    noErrorsOrHelper = _ref$noErrorsOrHelper === void 0 ? false : _ref$noErrorsOrHelper,
    _ref$labelAlign = _ref.labelAlign,
    labelAlign = _ref$labelAlign === void 0 ? 'left' : _ref$labelAlign,
    _ref$valid = _ref.valid,
    valid = _ref$valid === void 0 ? [true, function () {}] : _ref$valid,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    _ref$errorText = _ref.errorText,
    errorText = _ref$errorText === void 0 ? '' : _ref$errorText,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (errorText !== '' && error === false) {
    console.error("Prop \"errorText\" requires an error prop to be passed to Input to display the errorText.");
  }
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    validDate = _useState2[0],
    setValidDate = _useState2[1];
  var _useState3 = (0, _react.useState)({
      day: value ? value.split('/')[1] : '',
      month: value ? value.split('/')[0] : '',
      year: value ? value.split('/')[2] : ''
    }),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    val = _useState4[0],
    setVal = _useState4[1];
  var _useState5 = (0, _react.useState)({
      day: false,
      month: false,
      year: false
    }),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    internalError = _useState6[0],
    setInternalError = _useState6[1];
  var dayRef = (0, _react.useRef)();
  var monthRef = (0, _react.useRef)(ref || '');
  var yearRef = (0, _react.useRef)();
  var _useState7 = (0, _react.useState)({
      day: Boolean(value),
      month: Boolean(value),
      year: Boolean(value)
    }),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    visited = _useState8[0],
    setVisited = _useState8[1];
  var _useState9 = (0, _react.useState)('Please enter a valid date.'),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    errorMessage = _useState10[0],
    setErrorMessage = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    dateReqError = _useState12[0],
    setDateReqError = _useState12[1];
  var _useState13 = (0, _react.useState)({
      month: false,
      day: false,
      year: false
    }),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    focussed = _useState14[0],
    setFocussed = _useState14[1];
  var daysInMonth = function daysInMonth(chosenMonth, chosenYear) {
    return new Date(chosenYear, chosenMonth, 0).getDate() || 31;
  };
  var currentMonth = new Date().getMonth();
  var currentDay = new Date().getDate();
  var currentYear = new Date().getFullYear();
  (0, _react.useEffect)(function () {
    var numberOfErrors = [internalError.day, internalError.month, internalError.year].filter(function (err) {
      return err === true;
    }).length;
    if (dateReqError) {
      setErrorMessage(requiredMessage || 'Date is required.');
    } else if (numberOfErrors > 1) {
      setErrorMessage(invalidErrorMessage || 'Please enter a valid date.');
    } else if (numberOfErrors === 1) {
      if (internalError.month) {
        setErrorMessage(invalidErrorMessage || 'Please enter a valid month.');
      }
      if (internalError.day) {
        setErrorMessage(invalidErrorMessage || 'Please enter a valid day.');
      }
      if (internalError.year) {
        setErrorMessage(invalidErrorMessage || 'Please enter a valid year.');
      }
    }
    if ((internalError.day || internalError.month || internalError.year) && valid && typeof valid[1] === 'function') {
      valid[1](false);
    } else if (valid && typeof valid[1] === 'function') {
      valid[1](true);
    }
  }, [error, dateReqError, val, internalError]);
  var moveToField = function moveToField(field) {
    field.current.focus();
  };
  (0, _react.useEffect)(function () {
    if (val.month.length === 2 && (parseInt(val.month, 10) < 1 || parseInt(val.month, 10) > 12)) {
      setInternalError(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          month: true
        });
      });
      setVal(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          month: ''
        });
      });
    } else if (val.month.length === 2 && parseInt(val.month, 10) >= 1 && parseInt(val.month, 10) <= 12) {
      setInternalError(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          month: false
        });
      });
      moveToField(dayRef);
    }
    if (val.month.length === 1 && parseInt(val.month, 10) > 1) {
      setVal(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          month: val.month.padStart(2, '0')
        });
      });
      moveToField(dayRef);
      setInternalError(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          month: false
        });
      });
    }
  }, [val.month]);
  (0, _react.useEffect)(function () {
    if (visited.month && visited.day && visited.year && (required && !val.day && !val.month && !val.year || !required && Object.values(val).filter(function (e) {
      return e !== '';
    }).length > 0 && Object.values(val).filter(function (e) {
      return e !== '';
    }).length < 3)) {
      // This check becomes true only when all three fields are just visited without entries by the user for the first time.
      setInternalError(function () {
        return {
          day: true,
          month: true,
          year: true
        };
      });
      setDateReqError(required);
    } else if (dateReqError && (val.day.length === 2 || val.month.length === 2 || val.year.length === 4)) {
      setDateReqError(false);
    }
    // all fields visited and not all entered
    if (Object.values(focussed).filter(function (e) {
      return e === false;
    }).length === 3 && Object.values(val).filter(function (e) {
      return e !== '';
    }).length > 0 && Object.values(val).filter(function (e) {
      return e !== '';
    }).length < 3) {
      setValidDate(false);
    }
    if (required && visited.month && !val.month || required && visited.day && !val.day) {
      setInternalError(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          month: required && visited.month && !val.month,
          day: required && visited.day && !val.day
        });
      });
    } else {
      if (!validDate) {
        setInternalError(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            month: !val.month,
            day: !val.day,
            year: !val.year
          });
        });
      }
    }
    var noOfDays = daysInMonth(parseInt(val.month, 10), parseInt(val.year, 10));
    if (val.day.length === 2 && (parseInt(val.day, 10) < 1 || parseInt(val.day, 10) > noOfDays)) {
      setInternalError(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          day: true
        });
      });
      setVal(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          day: ''
        });
      });
    } else if (val.day.length === 2 && parseInt(val.day, 10) >= 1 && parseInt(val.day, 10) <= noOfDays) {
      setInternalError(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          day: false
        });
      });
      if (focussed.day) {
        moveToField(yearRef);
      }
    }
    if (val.day.length === 1 && parseInt(val.day, 10) > 3) {
      setVal(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          day: val.day.padStart(2, '0')
        });
      });
      if (focussed.day) {
        moveToField(yearRef);
      }
      setInternalError(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          day: false
        });
      });
    }
  }, [val, visited, validDate]);
  (0, _react.useEffect)(function () {
    if (val.year && val.year[0] === '1' && val.year[1] !== '9') {
      setVal(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          year: '1'
        });
      });
    } else if (val.year && val.year[0] !== '1' && val.year[0] !== '2') {
      setVal(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          year: ''
        });
      });
    }
  }, [val.year]);
  var validateValue = function validateValue(fieldValue, setFieldError, setField, field) {
    if (val.day === '0') {
      setFieldError(true);
      setField('');
      if (field === 'month') {
        setValue(" /".concat(val.day, "/").concat(val.year));
      } else if (field === 'day') {
        setValue("".concat(val.month, "/ /").concat(val.year));
      }
    } else if (fieldValue.length === 1) {
      setField(fieldValue.padStart(2, '0'));
      if (field === 'month') {
        setValue("".concat(fieldValue, "/").concat(val.day, "/").concat(val.year));
      } else if (field === 'day') {
        setValue("".concat(val.month, "/").concat(fieldValue, "/").concat(val.year));
      }
    }
  };
  var validateYear = function validateYear() {
    if (required && val.year === '' || parseInt(val.year, 10) < currentYear - 150 || restrictFutureDates && (parseInt(val.year, 10) > currentYear || parseInt(val.year, 10) === currentYear && parseInt(val.month, 10) > currentMonth + 1 || parseInt(val.year, 10) === currentYear && parseInt(val.month, 10) === currentMonth + 1 && parseInt(val.day, 10) > currentDay)) {
      setInternalError(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          year: true
        });
      });
      setVal(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          year: ''
        });
      });
      setValue("".concat(val.month, "/").concat(val.day, "/ "));
    } else {
      setInternalError(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          year: false
        });
      });
      setValue("".concat(val.month, "/").concat(val.day, "/").concat(val.year));
    }
  };
  (0, _react.useEffect)(function () {
    if (onChange) {
      onChange(value);
    }
  }, [value]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "InputDate ".concat(className, " ").concat(disabled ? 'InputDate__disabled' : ''),
    children: [!advanced && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Label["default"], {
      helperText: helperText,
      className: labelClass,
      tooltip: tooltip,
      tooltipAlign: tooltipNotchPosition,
      mobileTooltipAlign: mobileTooltipNotchPosition,
      required: required,
      error: internalError.month || internalError.day || internalError.year || error,
      children: label
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("fieldset", {
      className: "InputDate__group",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputBase["default"], _objectSpread(_objectSpread({}, rest), {}, {
        type: "tel",
        className: "InputDate__month ",
        advanced: advanced,
        noErrorsOrHelper: true,
        id: "input_date__month--".concat(id || label),
        ref: monthRef,
        onBlur: function onBlur() {
          setVisited(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              month: true
            });
          });
          validateValue(val.month, function (err) {
            setInternalError(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                month: err
              });
            });
          }, function (v) {
            setVal(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                month: v
              });
            });
          }, 'month');
          setFocussed(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              month: false
            });
          });
        },
        setValue: function setValue(mm) {
          return setVal(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              month: mm.replace(/[^0-9]+/g, '')
            });
          });
        },
        label: advanced ? 'mm' : '',
        value: val.month,
        onFocus: function onFocus() {
          setFocussed(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              month: true
            });
          });
        },
        maxLength: 2,
        error: error || internalError.month,
        labelAlign: labelAlign,
        hideAlertIcon: true,
        "aria-required": required,
        "aria-disabled": disabled,
        "aria-describedby": "".concat(advanced ? "".concat(id || label, "__input_date__adv__helper") : "".concat(id || label, "__input_date__helper"), " ").concat(id || label, "__input_date__desc"),
        "aria-label": "Month Field",
        "aria-invalid": internalError.month,
        "aria-errormessage": "".concat(id || label, "__input_date__adv__helper")
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "InputDate__separator",
        children: "/"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputBase["default"], _objectSpread(_objectSpread({}, rest), {}, {
        type: "tel",
        className: "InputDate__day",
        advanced: advanced,
        id: "input_date__day--".concat(id || label),
        ref: dayRef,
        noErrorsOrHelper: true,
        onBlur: function onBlur() {
          setVisited(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              day: true
            });
          });
          validateValue(val.day, function (err) {
            setInternalError(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                day: err
              });
            });
          }, function (v) {
            setVal(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                day: v
              });
            });
          }, 'day');
          setFocussed(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              day: false
            });
          });
        },
        setValue: function setValue(dd) {
          return setVal(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              day: dd.replace(/[^0-9]+/g, '')
            });
          });
        },
        onFocus: function onFocus() {
          setFocussed(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              day: true
            });
          });
        },
        value: val.day,
        label: advanced ? 'dd' : '',
        maxLength: 2,
        error: error || internalError.day,
        labelAlign: labelAlign,
        hideAlertIcon: true,
        "aria-required": required,
        "aria-disabled": disabled,
        "aria-describedby": "".concat(advanced ? "".concat(id || label, "__input_date__adv__helper") : "".concat(id || label, "__input_date__helper"), " ").concat(id || label, "__input_date__desc"),
        "aria-label": "Day field",
        "aria-invalid": internalError.day,
        "aria-errormessage": "".concat(id || label, "__input_date__adv__helper")
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "InputDate__separator",
        children: "/"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputBase["default"], _objectSpread(_objectSpread({}, rest), {}, {
        type: "tel",
        className: "InputDate__year",
        advanced: advanced,
        ref: yearRef,
        id: "input_date__year--".concat(id || label),
        noErrorsOrHelper: true,
        tooltip: advanced ? tooltip : '',
        tooltipNotchPosition: advanced ? tooltipNotchPosition : undefined,
        mobileTooltipNotchPosition: advanced ? mobileTooltipNotchPosition : null,
        onBlur: function onBlur() {
          setVisited(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              year: true
            });
          });
          setFocussed(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              year: false
            });
          });
          validateYear();
        },
        setValue: function setValue(yyyy) {
          setVal(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              year: yyyy.replace(/[^0-9]+/g, '')
            });
          });
        },
        onFocus: function onFocus() {
          setFocussed(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              year: true
            });
          });
        },
        value: val.year,
        label: advanced ? 'yyyy' : '',
        maxLength: 4,
        error: error || internalError.year,
        labelAlign: labelAlign,
        hideAlertIcon: true,
        "aria-required": required,
        "aria-disabled": disabled,
        "aria-describedby": "".concat(advanced ? "".concat(id || label, "__input_date__adv__helper") : "".concat(id || label, "__input_date__helper"), " ").concat(id || label, "__input_date__desc"),
        "aria-label": "Year field",
        "aria-invalid": internalError.year,
        "aria-errormessage": "".concat(id || label, "__input_date__adv__helper")
      }))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "InputDate__error_text ".concat(internalError.month || internalError.day || internalError.year || error ? 'error' : ''),
      id: "".concat(id || label, "__input_date__adv__helper"),
      "aria-live": "assertive",
      children: internalError.month || internalError.day || internalError.year ? errorMessage : error ? errorText : advanced ? helperText : description
    })]
  });
});
InputDate.displayName = 'InputDate';
var _default = InputDate;
exports["default"] = _default;